export const COMPANY = {
  name: 'Waras',
  email: 'warasdelivery@gmail.com',
  whatsapp: '51952686550',
  hours: '8:00 AM – 11:00 PM',
  city: 'Huaraz, Perú',
  playStore: 'https://play.google.com/store/apps/details?id=com.warasdelivery.tiendawaras',
  restaurantUrl: 'https://restaurant.warasdelivery.com',
};

export const contact = [
  {
    icon: 'mail',
    title: 'Correo',
    subtitle: 'Te respondemos a la brevedad.',
    description: COMPANY.email,
  },
  {
    icon: 'map',
    title: 'Ubicación',
    subtitle: COMPANY.city,
    description: 'Servicio en toda la ciudad y zonas aledañas',
  },
  {
    icon: 'clock',
    title: 'Horario de atención',
    subtitle: 'Lunes a domingo',
    description: COMPANY.hours,
  },
];

export const clientServices = [
  {
    key: 'restaurantes',
    name: 'Restaurantes',
    description: 'Pide de pollerías, cevicherías y locales de Huaraz con seguimiento en tiempo real.',
  },
  {
    key: 'mercado',
    name: 'Mercado',
    description: 'Abarrotes y productos del día, directo a tu puerta.',
  },
  {
    key: 'farmacia',
    name: 'Farmacia',
    description: 'Medicinas y cuidado personal cuando los necesitas.',
  },
  {
    key: 'licores',
    name: 'Licores',
    description: 'Bebidas para tu reunión, con entrega rápida y discreta.',
  },
  {
    key: 'regalos',
    name: 'Regalos',
    description: 'Detalles y encargos para sorprender sin salir de casa.',
  },
  {
    key: 'paqueteria',
    name: 'Paquetería',
    description: 'Envíos express en 10–15 minutos desde el recojo.',
  },
  {
    key: 'viajes',
    name: 'Viajes',
    description: 'Traslados puntuales dentro de Huaraz desde la app.',
  },
  {
    key: 'gas',
    name: 'Gas a domicilio',
    description: 'Pide gas y recíbelo con partners conectados a nuestra red.',
  },
  {
    key: 'encargos',
    name: 'Compras por encargo',
    description: 'Si el local no está afiliado, un motorizado compra y te lo lleva.',
  },
];

export const platforms = [
  {
    key: 'delivery',
    eyebrow: 'Logística y marketplace',
    name: 'Waras Delivery',
    description:
      'La super-app de Huaraz: comida, mercado, farmacia, paquetería, viajes y más. Todo el servicio de Delivery es gratis: sin mensualidad ni comisión extra.',
    points: [
      'App, web, panel y app socios: gratis',
      'Afiliación de negocios: gratis',
      'Registro de motorizados: gratis',
      'Sin mensualidad ni comisión extra',
    ],
    badge: 'Gratis',
    cta: { label: 'Ver servicios', href: '/', hash: '#servicios' },
    secondary: { label: 'Afiliar mi negocio', href: '/afiliate' },
  },
  {
    key: 'restaurants',
    eyebrow: 'Software para locales',
    name: 'Waras Restaurants',
    description:
      'Administra tu restaurante en un solo lugar: POS, mesas, reservas, cocina, carta QR, inventario, caja y reportes. 14 días de prueba.',
    points: [
      'Punto de venta e IGV',
      'Mesas, KDS y carta QR',
      'Inventario y caja',
      'Planes desde S/ 99 al mes',
    ],
    cta: { label: 'Conocer la plataforma', href: '/restaurantes' },
    secondary: { label: 'Probar 14 días', href: 'https://restaurant.warasdelivery.com', external: true },
  },
];

export const businessBenefits = [
  {
    title: 'Panel web y app socios',
    description: 'Gestiona delivery, carta, pedidos y reportes desde la computadora o el celular.',
  },
  {
    title: 'Flota Waras',
    description: 'Motorizados asignados de forma inteligente. Tú te enfocas en la cocina.',
  },
  {
    title: 'Afiliación 100% gratis',
    description: 'Sin mensualidad ni comisión extra. El panel, la app de socios y la flota no tienen costo.',
  },
  {
    title: 'Tracking y tiempos',
    description: 'Calculadora de delivery, historial y monitoreo del pedido hasta la puerta.',
  },
];

export const businessSteps = [
  {
    step: '01',
    title: 'Contáctanos',
    description: 'Envía los datos de tu local por WhatsApp, correo o el formulario de contacto.',
  },
  {
    step: '02',
    title: 'Configuración',
    description: 'Activamos tu cuenta, carta y horarios en el panel de socios.',
  },
  {
    step: '03',
    title: 'A operar',
    description: 'Empiezas a recibir pedidos con nuestra flota. Las dos primeras entregas pueden ser de prueba.',
  },
];

export const restaurantModules = [
  { name: 'Dashboard', description: 'Resumen de ventas, pedidos pendientes e indicadores del día.' },
  { name: 'Punto de venta', description: 'Toma pedidos con IGV, descuentos, promociones y varios medios de pago.' },
  { name: 'Mesas y zonas', description: 'Salón, terraza y barra con estados en tiempo real; libera mesa al cobrar.' },
  { name: 'Reservas', description: 'Registra reservas y asigna mesas sin sobreventa.' },
  { name: 'Pedidos', description: 'Historial, aprobación de Carta QR y seguimiento de estados.' },
  { name: 'Cocina (KDS)', description: 'Comandas en pantalla para cocina, con avance en vivo.' },
  { name: 'Monitor de pedidos', description: 'Pantalla de listos y entregados para salón o delivery.' },
  { name: 'Caja', description: 'Cobros, apertura, movimientos, cierre y arqueo imprimible.' },
  { name: 'Categorías y carta', description: 'Productos, precios, costos, atributos y disponibilidad.' },
  { name: 'Carta QR', description: 'Menú digital por mesa; el cliente pide desde el celular.' },
  { name: 'Kiosko', description: 'Modo autoservicio para que el comensal arme su pedido.' },
  { name: 'Clientes', description: 'Base de clientes con historial y puntos de fidelidad.' },
  { name: 'Inventario y Kardex', description: 'Insumos, stock mínimo, recetas y trazabilidad.' },
  { name: 'Promociones', description: 'Cupones y ofertas aplicables directamente en el POS.' },
  { name: 'Reportes', description: 'Ventas, top productos, rentabilidad y exportación CSV/PDF.' },
  { name: 'Usuarios y permisos', description: 'Roles y módulos configurables por local.' },
];

export const restaurantPreviewModules = [
  'Punto de venta',
  'Mesas y zonas',
  'Cocina (KDS)',
  'Carta QR',
  'Inventario',
  'Caja y reportes',
];

export const restaurantPlans = [
  {
    name: 'Profesional',
    audience: 'Para restaurantes en crecimiento',
    price: 'S/ 99',
    period: '/mes',
    popular: true,
    features: [
      '30 mesas',
      '200 productos',
      '15 usuarios',
      'Reservas e inventario',
      'Reportes avanzados',
      'Soporte prioritario',
    ],
  },
  {
    name: 'Premium',
    audience: 'Sin límites para cadenas',
    price: 'S/ 249',
    period: '/mes',
    popular: false,
    features: [
      'Mesas ilimitadas',
      'Productos ilimitados',
      'Usuarios ilimitados',
      'Todo lo del plan Profesional',
      'Soporte 24/7',
    ],
  },
];

export const restaurantFlow = [
  'Comandas a cocina en tiempo real (KDS)',
  'Recetas y control de costos por plato',
  'Apertura y cierre de caja con arqueo',
  'Reportes de ventas y rentabilidad',
];

export const stats = [
  { number: '150+', label: 'Negocios afiliados', description: 'Locales de confianza en Huaraz' },
  { number: '10+', label: 'Motorizados activos', description: 'Flota de reparto disponible' },
  { number: '15 min', label: 'Tiempo promedio', description: 'Desde el recojo del pedido' },
];

export const coverageZones = [
  { name: 'Centro de Huaraz', time: '10–15 min', description: 'Zona céntrica con alta densidad de negocios' },
  { name: 'Pedregal', time: '15–20 min', description: 'Zona residencial y comercial' },
  { name: 'Centenario', time: '12–18 min', description: 'Zona residencial con múltiples opciones' },
  { name: 'Belén', time: '15–20 min', description: 'Zona tradicional y comercial' },
  { name: 'La Soledad', time: '18–25 min', description: 'Zona en expansión' },
  { name: 'San Jerónimo', time: '20–25 min', description: 'Zona residencial y turística' },
  { name: 'Shancayan', time: '15–20 min', description: 'Zona residencial consolidada' },
  { name: 'Patay', time: '18–22 min', description: 'Zona residencial y comercial' },
  { name: 'Nueva Florida', time: '20–25 min', description: 'Zona residencial en crecimiento' },
  { name: 'Monterrey', time: '22–28 min', description: 'Zona residencial y turística' },
  { name: 'Vichay', time: '18–23 min', description: 'Zona residencial tradicional' },
  { name: 'Palmira', time: '20–25 min', description: 'Zona residencial' },
  { name: 'Acovichay', time: '15–20 min', description: 'Zona residencial y comercial' },
  { name: 'Huarupampa', time: '12–18 min', description: 'Zona residencial cercana al centro' },
  { name: 'La Victoria', time: '18–23 min', description: 'Zona residencial' },
  { name: 'Los Olivos', time: '20–26 min', description: 'Zona residencial' },
  { name: 'San Francisco', time: '16–21 min', description: 'Zona residencial y comercial' },
];

export const faqs = [
  {
    category: 'Para negocios',
    questions: [
      {
        question: '¿Cuánto cuesta afiliarme a Waras Delivery?',
        answer:
          'Es gratis. Sin mensualidad ni comisión extra. Waras Delivery no cobra por afiliarte, por el panel ni por la app.',
      },
      {
        question: '¿Cómo funciona el proceso de entrega?',
        answer:
          'Cuando llega un pedido, el sistema asigna un motorizado disponible. Recoge en tu local y entrega al cliente en el tiempo estimado.',
      },
      {
        question: '¿Qué diferencia hay con Waras Restaurants?',
        answer:
          'Waras Delivery (app, afiliación, panel y motorizados) es gratis. Waras Restaurants es el software de salón (POS, mesas, cocina, carta QR) y tiene planes de pago. Puedes usarlos juntos o por separado.',
      },
      {
        question: '¿Qué horarios cubren las entregas?',
        answer: `El servicio opera de ${COMPANY.hours}, todos los días. Configuras los horarios de tu local en el panel.`,
      },
    ],
  },
  {
    category: 'Para motorizados',
    questions: [
      {
        question: '¿Cuánto puedo ganar como motorizado?',
        answer:
          'Ganas por cada pedido entregado, más las propinas. Tú decides cuánto conectarte y trabajar.',
      },
      {
        question: '¿Necesito tener mi propia moto?',
        answer:
          'Sí. Moto en buen estado, documentos al día y licencia de conducir vigente.',
      },
      {
        question: '¿Puedo trabajar en mis propios horarios?',
        answer:
          'Sí. Activas o desactivas tu disponibilidad en la app cuando quieras.',
      },
      {
        question: '¿Cuánto cuesta registrarme como motorizado?',
        answer: 'Nada. El registro y la app de reparto son gratis. Ganas por cada pedido y te quedas las propinas.',
      },
    ],
  },
  {
    category: 'General',
    questions: [
      {
        question: '¿Los servicios de Waras Delivery tienen costo?',
        answer:
          'No. Pedir en la app, afiliar tu negocio, el panel de socios y ser motorizado son gratis. El único servicio con planes de pago es Waras Restaurants.',
      },
      {
        question: '¿Qué zonas cubren en Huaraz?',
        answer: 'Cubrimos Huaraz y zonas aledañas. Si no estás seguro, contáctanos.',
      },
      {
        question: '¿Cuál es el tiempo promedio de entrega?',
        answer:
          'Aproximadamente 15 minutos desde el recojo. En zonas más alejadas puede llegar a 20–25 minutos.',
      },
      {
        question: '¿Cómo los contacto?',
        answer: `Escríbenos a ${COMPANY.email}, por WhatsApp o con el formulario de contacto.`,
      },
    ],
  },
];

export const services = clientServices.slice(0, 4).map((s) => ({
  name: s.name,
  description: s.description,
}));

export const services2 = [
  {
    name: 'Horario',
    description: `Soporte y motorizados de ${COMPANY.hours}, todos los días.`,
  },
  {
    name: 'Tiempos de entrega',
    description: 'Entrega en unos 15 minutos desde el recojo del pedido.',
  },
];
